import apolloClient from 'ecommerce/utils/apolloClient';
import CancelOrderMutation from 'assets/graphql/mutations/CancelOrder.graphql';
import ChangeOrderProductQuantityMutation from 'ecommerce/assets/graphql/mutations/ChangeOrderProductQuantity.graphql';
import AddToCartMutation from 'assets/graphql/mutations/AddToCartMutation.graphql';


const useShoppingCartCleanUp = () => {
  const shoppingCartCleanUp = async (cart, productToAdd) => {
    if (!cart) { return }
    const productToAddHasPendingReservation = productToAdd.pending_reservation ? true : false
    let anyCartItemHasPendingReservation = false
    cart.item_lines.forEach(itemLine => {
      if (itemLine.pending_reservation !== null) {
        anyCartItemHasPendingReservation = true
      }
    })
    if (productToAddHasPendingReservation) {
      await apolloClient.mutate({
        mutation: CancelOrderMutation, // Removes all items from the cart
        variables: { order_signed_id: '' },
      });
    } else if (!productToAddHasPendingReservation && anyCartItemHasPendingReservation) {
      const product = {
        boxId: '',
        activityId: cart.items[0].product.id, // Using item 0 because if there is any item with reservation it should be an activity and the only one product in the cart
        quantity: 1,
        isGroup: false,
        source: '',
        boxType: 'digital',
        sellingSpotId: '',
        kindId: '',
      }
      // REMOVE ITEM WITH RESERVATION
      await apolloClient.mutate({
        mutation: ChangeOrderProductQuantityMutation,
        variables: {
          productId: cart.items[0].product.id,
          data: {
            quantity: 0,
          },
          order_signed_id: cart.signed_id,
        },
      });
      // ADD THE SAME ITEM WITHOUT THE RESERVATION
      await apolloClient.mutate({
        mutation: AddToCartMutation,
        variables: product,
      });
    }
  };

  return {
    shoppingCartCleanUp
  };
};

export default useShoppingCartCleanUp;
